import { useQuery } from '@tanstack/react-query';
import { getQuoteSummaryStatsQuery } from 'Services/Query/Quotes';
import {
  QuoteSummaryStatsBody,
  QuoteSummaryStatsFilter
} from 'Services/Query/Quotes/Types';

interface UseQuotesAnalyticsParams {
  statusId?: string;
  date?: string[];
  accountId?: string;
  limit?: number;
  offset?: number;
}

/**
 * Hook for fetching quotes analytics data
 * Returns metrics for the analytics cards
 */
export const useQuotesAnalytics = (params: UseQuotesAnalyticsParams = {}) => {
  // Build filters array
  const filters: QuoteSummaryStatsFilter[] = [
    {
      field: 'type',
      operator: '$eq',
      value: 'quote'
    }
  ];

  // Add account filter if accountId is provided
  if (params.accountId) {
    filters.push({
      field: 'account._id',
      operator: '$eq',
      value: params.accountId
    });
  }

  // Add date filter if date range is provided
  if (params.date && params.date.length === 2) {
    filters.push({
      field: 'createdAt',
      operator: '$between',
      value: params.date
    });
  }

  // Add status filter if statusId is provided
  if (params.statusId) {
    filters.push({
      field: 'statusId',
      operator: '$eq',
      value: params.statusId
    });
  }

  // Build request body
  const body: QuoteSummaryStatsBody = {
    limit: params.limit || 20,
    offset: params.offset || 0,
    filters: {
      $and: filters
    }
  };

  const { data, isLoading, error } = useQuery(getQuoteSummaryStatsQuery(body));

  return {
    analytics: data,
    loading: isLoading,
    error
  };
};
